/**
 * @returns A promise that resolves after the specified delay.
 * @remarks
 * Calling this function with `0` is a common way to defer execution until the next event loop iteration in Node.js.
 * @see {@link https://developer.mozilla.org/docs/Web/API/Window/setTimeout | MDN Web Docs} for in-depth behavior
 */
export const delay = (durationMillis: number): Promise<void> =>
  new Promise((resolve) => {
    setTimeout(resolve, durationMillis);
  });
